import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Button, Box, Dropdown, DropdownMenuItem} from 'views/components';
import {EditCalendar as EditCalendarIcon, Cancel as CancelIcon, ArrowBack as ArrowBackIcon} from 'views/icons';
import {Translate, translate, useNavigate, getEventStatusStyles} from 'views/module';

const EventHeader = (props) => {
  const {event, setModel, onUpdateShiftType} = props;

  const navigate = useNavigate();

  const [editingShiftType, setEditingShiftType] = React.useState(false);

  const statusStyles = getEventStatusStyles({event});

  const handleShiftTypeChange = (value) => {
    onUpdateShiftType(event.clientData.clientRn, event.eventRn, value, () => setEditingShiftType(false));
  };

  const handleCancelEvent = () => {
    setModel('CANCEL');
  };

  const handleRescheduleEvent = () => {
    setModel('RESCHEDULE');
  };

  return (
    <>
      <Stack
        direction={{xs: 'column', sm: 'row'}}
        alignItems={{xs: 'flex-start', sm: 'center'}}
        justifyContent="space-between"
        mb={2}
        spacing={1}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{flexWrap: 'wrap', minWidth: 0}}
        >
          <ArrowBackIcon
            sx={{color: 'black', cursor: 'pointer', mr: 1}}
            onClick={() => {
              if (window.history.length > 1) {
                navigate(-1);
              } else {
                navigate('/schedule/client');
              }
            }}
          />
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            sx={{
              background: statusStyles.background,
              color: statusStyles.textColor,
              border: `1px solid ${statusStyles.borderColor}`,
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              fontSize: {xs: '12px', sm: '14px'},
              mr: 1,
              mb: {xs: 0.5, sm: 0},
              whiteSpace: 'nowrap',
            }}
          >
            {statusStyles.label}
          </Typography>
          {
            editingShiftType ? (
              <Box sx={{minWidth: 220, mr: 1, mb: {xs: 0.5, sm: 0}}}>
                <Dropdown
                  value={event.shiftType || 'REGULAR_CARE'}
                  onChange={handleShiftTypeChange}
                  label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.ShiftType.Label')}
                >
                  {
                    ['REGULAR_CARE', 'FIRST_SHIFT_LONG_TERM_CLIENT', 'MEET_AND_GREET', 'ONE_TIME_REPLACEMENT', 'TEMPORARY_REPLACEMENT'].map((shiftTypeKey) => {
                      return (
                        <DropdownMenuItem key={shiftTypeKey} value={shiftTypeKey}>
                          {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.ShiftType.Options.${shiftTypeKey}`)}
                        </DropdownMenuItem>
                      );
                    })
                  }
                </Dropdown>
              </Box>
            ) : (
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                onClick={() => setEditingShiftType(true)}
                sx={{
                  background: '#f5f5f5',
                  color: '#616161',
                  border: '1px solid #9e9e9e',
                  borderRadius: 2,
                  px: 1.5,
                  py: 0.5,
                  fontSize: {xs: '12px', sm: '14px'},
                  mr: 1,
                  mb: {xs: 0.5, sm: 0},
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                }}
              >
                {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.ShiftType.Options.${event.shiftType || 'REGULAR_CARE'}`)}
              </Typography>
            )
          }
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{
              fontSize: {xs: '1.1rem', sm: '1.25rem'},
              wordBreak: 'break-word',
              maxWidth: {xs: '180px', sm: 'none'},
              flexShrink: 1,
            }}
          >
            {event.info.title}
          </Typography>
        </Stack>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          spacing={1}
          sx={{width: {xs: '100%', sm: 'auto'}, mt: {xs: 1, sm: 0}}}
        >
          <Button
            variant="outlined"
            color="black"
            startIcon={<EditCalendarIcon />}
            onClick={handleRescheduleEvent}
            sx={{width: {xs: '100%', sm: 'auto'}}}
          >
            <Translate expression='schedule.eventDetail.Header.RescheduleButton'/>
          </Button>
          <Button
            variant="outlined"
            color="error"
            startIcon={<CancelIcon />}
            onClick={handleCancelEvent}
            sx={{width: {xs: '100%', sm: 'auto'}}}
          >
            <Translate expression='schedule.eventDetail.Header.CancelButton'/>
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
  setModel: PropTypes.func.isRequired,
  onUpdateShiftType: PropTypes.func.isRequired,
};

export default EventHeader;
